"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeTimeline = void 0;
function mergeTimeline(base, ads) {
    if (ads.length === 0)
        return base;
    if (base.length === 0)
        return ads;
    var adjusted = base.flatMap(function (baseEvent) {
        return adjustTimelineEvent(baseEvent, ads);
    });
    adjusted.push.apply(adjusted, ads);
    adjusted.sort(function (a, b) { return a.start - b.start; });
    return adjusted;
}
exports.mergeTimeline = mergeTimeline;
function adjustTimelineEvent(original, advertisements) {
    var start = original.start, end = original.end;
    var adjusted = [];
    for (var _i = 0, advertisements_1 = advertisements; _i < advertisements_1.length; _i++) {
        var advertisement = advertisements_1[_i];
        if (advertisement.start <= start && advertisement.end > start) {
            start = advertisement.end;
        }
        else if (advertisement.start > start && advertisement.start < end) {
            adjusted.push(__assign(__assign({}, original), { start: start, end: advertisement.start }));
            start = advertisement.end;
        }
    }
    if (start < end) {
        adjusted.push(__assign(__assign({}, original), { start: start, end: end }));
    }
    return adjusted;
}
//# sourceMappingURL=mergeTimeline.js.map